import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import useBundleTranslation from 'i18n';
import { renderToString } from 'react-dom/server';
import PageErrorBlock from 'components/common/error/PageErrorBlock';

interface RequestErrorMessageProps {
    view?: 'inline' | 'page';
    error: any;
    extraData?: any;
}

export const getRequestErrorHtmlString = (props: RequestErrorMessageProps) => {
    return renderToString(<RequestErrorMessage {...props} />);
};

export default function RequestErrorMessage(props: RequestErrorMessageProps) {
    const { t } = useBundleTranslation(['components/error/request_error_message']);
    const { view = 'inline', error, extraData = {} } = props;

    const errorType = useMemo(() => {
        if (error!.message === 'Network Error') return 'network'; //need test //error.code "ERR_NETWORK"
        if (error?.message === 'Request failed with status code 400' && extraData.uploadedFileFieldsAmount)
            return 'network'; //Some workaround for files
        if (error!.status === 500) return 'internal_server';

        return 'common';

        //code "ERR_NETWORK"
        //message: "Network Error"
        //request.status 0 500
    }, [error]);

    const errorMessageData = useMemo(() => {
        const iconAliases = {
            network: 'wireless-error',
            internal_server: 'alert',
        };
        const message = {
            title: t('error_common.title'),
            subTitle: error!.message,
            icon: 'alert',
        };
        if (errorType !== 'common') {
            message.title = t(`error_${errorType}.title`);
            message.subTitle = t(`error_${errorType}.sub_title`);
            message.icon = iconAliases[errorType];
        }
        return message;
    }, [errorType]);

    if (errorType == 'internal_server' && view === 'page') {
        return (
            <Box className={'page-request-error-message'}>
                <PageErrorBlock
                    errorType={errorType}
                    errorTitle={t('page_error_internal_server.title')}
                    errorMessage={t('page_error_internal_server.sub_title')}
                />
            </Box>
        );
    }

    return (
        <Box className={`request-error-message request-error-message--view-${view}`}>
            <Box className={'request-error-message__icon-holder'}>
                <IconMi icon={errorMessageData.icon} />
            </Box>
            <Box className={'request-error-message__text-holder'}>
                <Box>{errorMessageData.title}</Box>
                <Box>{errorMessageData.subTitle}</Box>
            </Box>
        </Box>
    );
}
